import { GeoPoint } from '@youhelp-ru/core';
import { LocationSuggestion } from '@common/model/location/locationSuggestion';
import { CityViewModel } from '@common/model/location/cityViewModel';

/**
 * Try to get user location from available sources
 */
export const getMapLocation = (
  address?: LocationSuggestion | null,
  city?: CityViewModel | null,
  deviceLocation?: GeoPoint | null,
): GeoPoint | null => {
  let location: GeoPoint | null = null;
  if (address?.location) {
    location = GeoPoint.parse('geo:' + address.location);
  } else if (city?.centerPoint) {
    location = GeoPoint.parse('geo:' + city.centerPoint);
  } else if (deviceLocation) {
    location = deviceLocation;
  }
  return location;
};
